import * as Types from '../../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
import { OrderabilityFragmentFragmentDoc } from '../../../../../fragments/__generated__/orderability.graphql-interface'
export type OutletAvailabilityQueryVariables = Types.Exact<{
  outletId: Types.Scalars['String']
  fulfilmentMethod: Types.NarrowFulfilmentMethodInputType
  fulfilmentLocation?: Types.InputMaybe<Types.FulfilmentLocationInput>
}>

export type OutletAvailabilityQuery = {
  outlet: {
    __typename: 'Outlet'
    id: string
    closedUntil: string | null
    nextOpenDate: string
    isOpen: boolean
    isOnline: boolean
    prepTime: number
    collectionPreorderTimes: Array<string>
    openingTimesArray: Array<{
      __typename: 'OpeningTime'
      id: string
      timeSlot: number
      start: { __typename: 'DayAndTime'; id: string; day: number; time: string }
      end: { __typename: 'DayAndTime'; id: string; day: number; time: string }
    }>
    orderability: {
      __typename: 'OrderabilityOutput'
      prioritisedGenerallyAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
      prioritisedCurrentlyAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
      prioritisedGenerallyLocationAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
      prioritisedCurrentlyLocationAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
      delivery: {
        __typename: 'FulfilmentMethodOrderability'
        isGenerallyAvailable: boolean
        isAvailableToLocation: boolean
        asap: {
          __typename: 'FulfilmentMethodASAPOrderability'
          isGenerallyAvailable: boolean
          isAvailableNow: boolean
          availableFrom: string | null
          validUntil: string | null
        }
        preorder: {
          __typename: 'FulfilmentMethodPreorderOrderability'
          isGenerallyAvailable: boolean
          isAvailableForSelectedDate: boolean
          nextPreorderFulfilledAt: string | null
          isPreorderForLocalToday: boolean | null
        }
      }
      collection: {
        __typename: 'FulfilmentMethodOrderability'
        isGenerallyAvailable: boolean
        isAvailableToLocation: boolean
        asap: {
          __typename: 'FulfilmentMethodASAPOrderability'
          isGenerallyAvailable: boolean
          isAvailableNow: boolean
          availableFrom: string | null
          validUntil: string | null
        }
        preorder: {
          __typename: 'FulfilmentMethodPreorderOrderability'
          isGenerallyAvailable: boolean
          isAvailableForSelectedDate: boolean
          nextPreorderFulfilledAt: string | null
          isPreorderForLocalToday: boolean | null
        }
      }
      table: {
        __typename: 'FulfilmentMethodOrderability'
        isGenerallyAvailable: boolean
        isAvailableToLocation: boolean
        asap: {
          __typename: 'FulfilmentMethodASAPOrderability'
          isGenerallyAvailable: boolean
          isAvailableNow: boolean
          availableFrom: string | null
          validUntil: string | null
        }
        preorder: {
          __typename: 'FulfilmentMethodPreorderOrderability'
          isGenerallyAvailable: boolean
          isAvailableForSelectedDate: boolean
          nextPreorderFulfilledAt: string | null
          isPreorderForLocalToday: boolean | null
        }
      }
      anyFulfilmentMethod: {
        __typename: 'FulfilmentMethodOrderability'
        isGenerallyAvailable: boolean
        isAvailableToLocation: boolean
        asap: {
          __typename: 'FulfilmentMethodASAPOrderability'
          isGenerallyAvailable: boolean
          isAvailableNow: boolean
          availableFrom: string | null
          validUntil: string | null
        }
        preorder: {
          __typename: 'FulfilmentMethodPreorderOrderability'
          isGenerallyAvailable: boolean
          isAvailableForSelectedDate: boolean
          nextPreorderFulfilledAt: string | null
          isPreorderForLocalToday: boolean | null
        }
      }
    }
    deliveryPreorderWindows: Array<{
      __typename: 'DeliveryPreorderWindow'
      start: string
      end: string
      isFull: boolean
    }>
    statusText: {
      __typename: 'OutletStatusText'
      orderButtonTranslation: string
      openingTimeTranslation: {
        __typename: 'OpeningTimeTranslation'
        key: string
        datetime: string | null
        datetimeFormat: string | null
        days: string | null
      }
    }
  } | null
}

export const OutletAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OutletAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'outletId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fulfilmentMethod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NarrowFulfilmentMethodInputType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fulfilmentLocation' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FulfilmentLocationInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outlet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'outletId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedUntil' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'openingTimesArray' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'start' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'day' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'time' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'end' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'day' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'time' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlot' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextOpenDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isOpen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderability' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'fulfilmentLocation' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fulfilmentLocation' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OrderabilityFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'prepTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectionPreorderTimes' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deliveryPreorderWindows' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'returnFullWindows' },
                      value: { kind: 'BooleanValue', value: false },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFull' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusText' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'fulfilmentMethod' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fulfilmentMethod' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'openingTimeTranslation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'key' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'datetime' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'datetimeFormat' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'days' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderButtonTranslation' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...OrderabilityFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  OutletAvailabilityQuery,
  OutletAvailabilityQueryVariables
>
